import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';

interface BlurGateProps {
  children: React.ReactNode;
  /** When true, content is blurred and sign-in is required to interact. */
  gated: boolean;
  testId?: string;
}

/**
 * FEAT-066 (MVP-18.1) — overlays blurred discovery tiles for guests with a
 * sign-in prompt; visible tiles pass through unchanged.
 */
const BlurGate: React.FC<BlurGateProps> = ({ children, gated, testId }) => {
  const navigate = useNavigate();
  const { dispatch } = useApp();

  if (!gated) {
    return <>{children}</>;
  }

  const handleSignIn = () => {
    dispatch({ type: 'SET_REDIRECT_URL', payload: window.location.pathname });
    navigate('/auth');
  };

  return (
    <Box
      sx={{ position: 'relative' }}
      data-testid={testId ?? 'discovery-blur-gate'}
    >
      <Box
        sx={{
          filter: 'blur(6px)',
          pointerEvents: 'none',
          userSelect: 'none',
        }}
        aria-hidden
      >
        {children}
      </Box>
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          px: 2,
          textAlign: 'center',
          backgroundColor: 'rgba(255,255,255,0.55)',
        }}
      >
        <Typography variant="body2" color="text.secondary">
          Sign in to see more caregivers
        </Typography>
        <Button variant="contained" size="small" onClick={handleSignIn}>
          Sign in
        </Button>
      </Box>
    </Box>
  );
};

export default BlurGate;
